import React from 'react'

import pleft from './../../resources/HomePageResources/platform-down-left.svg'
import pright from './../../resources/HomePageResources/platform-down-right.svg'
import '../../styles/RoadMapStyles/rmtimer.css'



export default class Timer extends React.Component{
    constructor(props){
        super(props)
        this.state={
            daysLeft: 0,
            hoursLeft: 0,
            minutesLeft: 0,
            secondsLeft:0,
        }
    }
    componentDidMount() {

        this.interval = setInterval(() => this.setState({
            daysLeft: Math.floor((new Date("Oct 14, 2018 00:00:00").getTime()-new Date().getTime())/(1000 * 60 * 60 * 24)),
            hoursLeft: Math.floor(((new Date("Oct 14, 2018 00:00:00").getTime()-new Date().getTime()) % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutesLeft: Math.floor(((new Date("Oct 14, 2018 00:00:00").getTime()-new Date().getTime()) % (1000 * 60 * 60)) / (1000 * 60)),
            secondsLeft: Math.floor(((new Date("Oct 14, 2018 00:00:00").getTime()-new Date().getTime()) % (1000 * 60)) / 1000),
        }), 1000);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    render(){
        return(
            <div classname="rmt__container">
                <div className="rmt__content">
                    <div className="rmt__text text">End of ICO Through:</div>

                    <div className="tc__timer-container">
                        <div className="tc__timer-box">
                            <div className="tc__timer-number">{15}</div>
                            <div className="tc__timer-unit">days</div>
                        </div>
                        <div className="tc__timer-box">
                            <div className="tc__timer-number">{15}</div>
                            <div className="tc__timer-unit">hours</div>
                        </div>
                        <div className="tc__timer-box">
                            <div className="tc__timer-number">{7}</div>
                            <div className="tc__timer-unit">minutes</div>
                        </div>
                        <div className="tc__timer-box">
                            <div className="tc__timer-number">{15}</div>
                            <div className="tc__timer-unit">seconds</div>
                        </div>
                    </div>

                </div>

                <div className="rmt__plat">
                    <img className="rmt__plat-left" src={pleft} />
                    <div className="rmt__plat-p" />
                    <img className="rmt__plat-right" src={pright} />
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/RoadMap/Timer.js